// extracted by mini-css-extract-plugin
export default {"container":"ReferralLinkBox_container__+RUA+","linkBox":"ReferralLinkBox_linkBox__PRtoj","link":"ReferralLinkBox_link__+USt3","copyButton":"ReferralLinkBox_copyButton__XMaz1"};